export default {
  title: "Plafonds déductibles de l'impôt sur le revenu",
  subtitle: "En cas de versements sur contrat d'épargne retraite",
  sectionTitle: 'Année fiscale {year}',
  label: {
    unusedCapPastYears: 'Plafond non utilisé (N-{n})',
    unusedCapCurrentYear: 'Plafond calculé sur les revenus (N-1)',
    deductibleCap: 'Plafond total pour les versements',
    currentYearDeposits: 'Versements réalisés',
    remainingCap: 'Disponible restant sur le plafond total',
  },
  tooltip: {
    card: "Le plafond déductible de l'impôt sur le revenu correspond au montant maximal pouvant être déduit du revenu imposable pour des cotisations versées dans un plan d'épargne retraite.",
    deductibleCap:
      "Le montant total pouvant être déduit du revenu imposable de l'année en cours en incluant le plafond de déduction non consommé des 3 dernières années.",
    remainingCap:
      "Le montant pouvant être déduit du revenu imposable de l'année en cours en prenant en compte les versements déjà effectués de l'année en cours.",
  },
}
